



  import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"Profil"
})
export default class Profil extends Vue {}
